import type { Option } from '@components/forms/GridSelect';

export enum SystemFilterOption {
    Model = 'model',
    Status = 'status',
    Company = 'companies',
    Reseller = 'resellers',
    Location = 'locations',
}

export enum System {
    RapidCut = 'RC2/RC3',
    RCMini = 'RCMini',
}

export enum SystemStatus {
    Active = 'Active',
    Inactive = 'Inactive',
    Replaced = 'Replaced',
    Standby = 'Standby',
}

export const SystemModelMap: { [key: string]: System } = {
    0: System.RapidCut,
    1: System.RCMini,
};

export const SYSTEM_STATUS_OPTIONS: Option[] = Object.entries(SystemStatus).map(([label, value]) => {
    return {
        label,
        value,
    };
});

export const COMPATIBILITY_OPTIONS = [System.RCMini, System.RapidCut];
